import { render, staticRenderFns } from "./RelatedStaff.vue?vue&type=template&id=738bdd84&"
import script from "./RelatedStaff.vue?vue&type=script&lang=js&"
export * from "./RelatedStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports